$('#upload_webinar_image').fileupload({
    url: '/upload/webinar_image',
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 12000000,
    multiple: false,
    dataType: 'json',
    single: true,
    add: function (e, data) {
        $(".webinars-bg-upload").removeClass('uploaded').addClass('uploading').removeAttr('style');
        $('#upload_webinar_image').next().val('');
        data.submit();
    },
    done: function (e, data) {
        console.log(data.result);
        $(".webinars-bg-upload").removeClass('uploading').addClass('uploaded');
        $(".webinars-bg-upload").css({'background-image': 'url(' + data.result.url + '?_'+Math.random() + ')'});
        $('#upload_webinar_image').next().val(data.result.path);
    },
    progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
    },
    fail: function (e, data) {
        try {
            console.log(data, data.jqXHR, data.jqXHR.responseJSON);
            swal({
                text: data.jqXHR.responseJSON.errors.file[0],
                icon: 'error'
            }).then(function () {
            });
        } catch (e) {
            swal({
                text: $('html').attr('lang') === 'ru' ? "Ошибка загрузки" : "Error uploading",
                icon: 'error'
            }).then(function () {
            });
        }
        $(".webinars-bg-upload").removeClass('uploading').removeClass('uploaded').removeAttr('style');
    }
});
$('#addWebinarDate').on('click', function () {
    $(this).before($('.webinars-datetime:first').clone());
    $(this).prev().addClass('reInit').find('.select2').each(function () {
        $(this).removeAttr('data-select2-id').next('.select2').remove();
    });
    if ($('.webinars-datetime').length >= 5) {
        $(this).addClass('hide');
    }
    $('.reInit .datepicker').datepicker({
        format: 'dd.mm.yyyy'
    });
    $('.reInit .default-select').select2({
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true
    });
    $('.reInit .default-select-search').select2({
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: 3,
        dropdownAutoWidth: true
    });
    return false;
});
$(document).on('click', '.remove-datetime a', function () {
    $(this).closest('.webinars-datetime').remove();
    if ($('.webinars-datetime').length < 5) {
        $('#addWebinarDate').removeClass('hide');
    }
    return false;
});

if ($('[data-timer]').length) {
    var locale = $('html').attr('lang');
    var decl = {
        "ru": {
            days: ['день', 'дня', 'дней'],
            hours: ['час', 'часа', 'часов'],
            minutes: ['минута', 'минуты', 'минут'],
            seconds: ['секунда', 'секунды', 'секунд'],
        },
        "en": {
            days: ['day', 'days', 'days'],
            hours: ['hour', 'hours', 'hours'],
            minutes: ['minute', 'minutes', 'minutes'],
            seconds: ['second', 'seconds', 'seconds'],
        }
    };
    setInterval(function () {
        $('[data-timer]').each(function () {
            $time = parseInt($(this).attr('data-timer'));
            if($time>0){
                $(this).attr('data-timer', $time - 1);
            }
            var seconds = Math.floor(($time) % 60);
            var minutes = Math.floor(($time / 60) % 60);
            var hours = Math.floor(($time / (60 * 60)) % 24);
            var days = Math.floor($time / (60 * 60 * 24));

            $(this).html(
                '<div class="days">' + ('0' + days).slice(-2) + '<span>' + decl[locale]['days'][2] + '</span></div>' +
                '<div class="hours">' + ('0' + hours).slice(-2) + '<span>' + decl[locale]['hours'][2] + '</span></div>' +
                '<div class="minutes">' + ('0' + minutes).slice(-2) + '<span>' +decl[locale]['minutes'][2] + '</span></div>' +
                '<div class="seconds">' + ('0' + seconds).slice(-2) + '<span>' + decl[locale]['seconds'][2] + '</span></div>'
            );
        });
    }, 1000);
}

$('#upload_course_teacher_photo').fileupload({
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 12000000,
    multiple: false,
    dataType: 'json',
    single: true,
    add: function (e, data) {
        data.url = '/upload/teacher_photo/'+parseInt($('#modal_curator input[name="id"]').val());
        $(".course-teacher-upload").removeClass('uploaded').addClass('uploading');
        $(".course-teacher-upload div").removeAttr('style');
        $(".course-teacher-upload svg").show();
        $('#upload_course_teacher_photo').next().val('');
        data.submit();
    },
    done: function (e, data) {
        $(".course-teacher-upload div").css({'background-image': 'url(' + data.result.url + '?_' + Math.random() + ')'});
        $('#upload_course_teacher_photo').next().val(data.result.path);
        $(".course-teacher-upload svg").hide();
    },
    progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
    },
    fail: function (e, data) {
        try {
            console.log(data, data.jqXHR, data.jqXHR.responseJSON);
            swal({
                text: data.jqXHR.responseJSON.errors.file[0],
                icon: 'error'
            }).then(function () {
            });
        } catch (e) {
            swal({
                text: $('html').attr('lang') === 'ru' ? "Ошибка загрузки" : "Error uploading",
                icon: 'error'
            }).then(function () {
            });
        }
        $(".course-teacher-upload").removeClass('uploading').removeClass('uploaded').removeAttr('style');
    }
});
$('#upload_conference_image').fileupload({
    url: '/upload/conference_image',
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 12000000,
    multiple: false,
    dataType: 'json',
    single: true,
    add: function (e, data) {
        $(".webinars-bg-upload").removeClass('uploaded').addClass('uploading').removeAttr('style');
        $('#upload_conference_image').next().val('');
        data.submit();
    },
    done: function (e, data) {
        console.log(data.result);
        $(".webinars-bg-upload").removeClass('uploading').addClass('uploaded');
        $(".webinars-bg-upload").css({'background-image': 'url(' + data.result.url + '?_'+Math.random() + ')'});
        $('#upload_conference_image').next().val(data.result.path);
    },
    progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
    },
    fail: function (e, data) {
        try {
            console.log(data, data.jqXHR, data.jqXHR.responseJSON);
            swal({
                text: data.jqXHR.responseJSON.errors.file[0],
                icon: 'error'
            }).then(function () {
            });
        } catch (e) {
            swal({
                text: $('html').attr('lang') === 'ru' ? "Ошибка загрузки" : "Error uploading",
                icon: 'error'
            }).then(function () {
            });
        }
        $(".webinars-bg-upload").removeClass('uploading').removeClass('uploaded').removeAttr('style');
    }
});

if( document.querySelector('.js-showTeacherPage') != null ) {
    document.querySelector('.js-showTeacherPage').addEventListener('click', function(){
        window.open( '/' + document.querySelector('html').getAttribute('lang') + '/teacher/' + document.querySelector( '#modal_curator [name="id"]').value, '_blank' );
    });
}
$(document).on('change','.js-invite', function (e){
    e.preventDefault();
    let elm = $(this);

    if (elm.is(':checked')) {
        elm.prop('checked', false);

        swal({
            title: window.lang.inviteHead,
            text: window.lang.inviteBody,
            icon: "warning",
            buttons: {
                cancel: {
                    text: window.lang.inviteCancel,
                    value: null,
                    visible: true,
                    className: "",
                    closeModal: true,
                },
                confirm: {
                    text: window.lang.inviteOk,
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: true
                }
            },
            dangerMode: true,
        })
            .then((willInvite) => {
                if (willInvite) {
                    elm.prop('checked', true);
                    elm.prop('disabled',true);
                    $.getJSON(elm.parent().data('link'),function (response){
                        elm.prop('disabled',false);
                        if(!response.hasOwnProperty('success') || !response.hasOwnProperty('invited')){
                            return false;
                        }
                        elm.prop('checked',response.invited);
                    }).fail(function (){
                        elm.prop('disabled',false);
                        elm.prop('checked', !elm.is(':checked'));
                    });

                    return false;
                }
            });
    } else {
        elm.prop('disabled',true);
        $.getJSON(elm.parent().data('link'),function (response){
            elm.prop('disabled',false);
            if(!response.hasOwnProperty('success') || !response.hasOwnProperty('invited')){
                return false;
            }
            elm.prop('checked',response.invited);
        }).fail(function (){
            elm.prop('disabled',false);
            elm.prop('checked', !elm.is(':checked'));
        });
    }
});
$(function(){
    $('form[data-ajax="1"] input[type="submit"], form[data-ajax="1"] button[type="submit"]').click(function (e) {
        const videoBlock = $('.videoLoadsBlock');
        videoBlock.html('');
        let videoLoads = localStorage.getItem('VideoLoads_' + $('meta[name="webinarId"]').attr('content'));

        console.log(videoLoads);

        if(videoLoads === null) return;
        videoLoads = JSON.parse(videoLoads);

        for(let videoId of videoLoads) {
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'ignoreVideo[]');
            input.setAttribute('value', videoId);

            videoBlock.append(input);
        }
    });
});
$('#upload_autowebinar_image').fileupload({
    url: '/upload/autowebinar_image',
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 12000000,
    multiple: false,
    dataType: 'json',
    single: true,
    add: function (e, data) {
        $(".webinars-bg-upload").removeClass('uploaded').addClass('uploading').removeAttr('style');
        $('#upload_webinar_image').next().val('');
        data.submit();
    },
    done: function (e, data) {
        console.log(data.result);
        $(".webinars-bg-upload").removeClass('uploading').addClass('uploaded');
        $(".webinars-bg-upload").css({'background-image': 'url(' + data.result.url + '?_'+Math.random() + ')'});
        $('#upload_autowebinar_image').next().val(data.result.path);
    },
    progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
    },
    fail: function (e, data) {
        try {
            console.log(data, data.jqXHR, data.jqXHR.responseJSON);
            swal({
                text: data.jqXHR.responseJSON.errors.file[0],
                icon: 'error'
            }).then(function () {
            });
        } catch (e) {
            swal({
                text: $('html').attr('lang') === 'ru' ? "Ошибка загрузки" : "Error uploading",
                icon: 'error'
            }).then(function () {
            });
        }
        $(".webinars-bg-upload").removeClass('uploading').removeClass('uploaded').removeAttr('style');
    }
});

let count_fields = 0;
$(document).ready(function() {
    if ($('.add_field_button').length) {
        count_fields = $('.add_field_button').data('count');
    }
});


$(document).on('click','.add_field_button',function (e){
   let count_fields = $(this).attr('data-count');
   let $areaa = $('#additional_fields');

   if (count_fields < 3) {
        count_fields++;
        $(this).attr('data-count', count_fields);
        $template = $('#additional_template').html();
        $template = $template.replace( /add_field_required_0/g ,'add_field_required_' + count_fields);
        $areaa.append($template);

    }
    if (count_fields === 3) {
        $(this).hide();
    }

   return false;
});

$(document).on('change','.req_ch',function (e){
    let $parent = $(this).closest('.check-field');
    let $val = $parent.find('.req_value');
    $val.val($(this).prop('checked') ? '1' : '0');
});

$(document).on('change','[name=phone_number]',function (e){
    console.log($(this).prop('checked'))
    if ( $(this).prop('checked') != $("[name=phone_number_required]").prop('checked') ) {
        $("[name=phone_number_required]").click();
    }

});



$(document).on('click', '.check-field .delete',function (e){
    let $but = $('.add_field_button');
    let $wrap = $(this).closest('.additional_field')
    let count_fields = $but.attr('data-count');
    count_fields--;
    $but.attr('data-count', count_fields);
    $($wrap).remove();

    $but.show();

    return false;
 });
